<template>
  <Popover class="relative" v-bind="$attrs">
    <PopoverButton
      class="filter-select relative border-4 border-b-0 h-10 w-full py-1 pl-1 pr-8 text-left bg-white cursor-pointer"
      :class="`border-${color}`"
    >
      <slot name="filterBtnContent"> </slot>
      <template v-if="!$slots.filterBtnContent">
        <span class="block truncate" :class="`text-${color}`"
          >すべてを表示</span
        >
      </template>
      <span
        class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none"
      >
        <chevron-icn
          width="20px"
          height="20px"
          :class="`${color}-icon`"
        ></chevron-icn>
      </span>
    </PopoverButton>
    <transition
      enter-active-class="transition duration-200 ease-out"
      enter-from-class="translate-y-1 opacity-0"
      enter-to-class="translate-y-0 opacity-100"
      leave-active-class="transition duration-150 ease-in"
      leave-from-class="translate-y-0 opacity-100"
      leave-to-class="translate-y-1 opacity-0"
    >
      <PopoverPanel
        v-if="filters.length"
        class="absolute w-full border-4 z-40 bg-white px-3"
        :class="`border-${color}`"
        style="border-radius: 0px 0px 20px 20px"
      >
        <slot name="filterContent"> </slot>
        <template v-if="!$slots.filterContent">
          <app-checkbox
            v-for="item in filters"
            :key="item.id"
            :fieldId="item.id"
            v-model:selectedOptions="selectedFilters"
            :value="item.title"
            :color="color"
          />
        </template>
      </PopoverPanel>
    </transition>
  </Popover>
</template>

<script>
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/vue'

import AppCheckbox from '@/components/ui/AppCheckbox'
import { useSelectFilter } from '@/services/useSelectFilter'

import ChevronIcn from '@/assets/icons/chevron.svg?inline'

import { ref } from 'vue'

export default {
  name: 'AppSelectFilter',

  components: {
    Popover,
    PopoverButton,
    PopoverPanel,
    ChevronIcn,
    AppCheckbox,
  },

  props: {
    color: {
      type: String,
      default: '',
    },
  },

  setup() {
    const { filters, selectedFilters, setFilters } = useSelectFilter()
    const useroptions = ref([])

    setFilters([
      { id: '1', title: '政務活動' },
      { id: '2', title: '領収書' },
      { id: '3', title: '予算' },
    ])

    return { filters, selectedFilters, useroptions }
  },
}
</script>

<style lang="scss" scoped>
.filter-select {
  box-sizing: border-box;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  width: 164px;
}

#headlessui-popover-panel-4 {
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
}
</style>
